import { rootRoute } from './root'
import { startRoute } from './start'
import { profileRoute } from './profile'

export const userRoute = rootRoute.addChildren([startRoute, profileRoute])
